import { render, staticRenderFns } from "./WeeklyOrder.vue?vue&type=template&id=637f7a6f"
import script from "./WeeklyOrder.vue?vue&type=script&lang=js"
export * from "./WeeklyOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports